var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Chart from './chart';
import { Scatter } from '../scatter';
import { expandRange } from '../../utilities';
class MultidimensionalChart extends React.Component {
    constructor(props, ref) {
        super(props);
        MultidimensionalChart.assertRectangularMatrix(props.data);
        this.state = {
            domains: props.domains || MultidimensionalChart.domains(props.data, props.domainExpansionFactor || 0.1),
            data: props.data,
            displayData: MultidimensionalChart.displayData(props.data, props.xDimension, props.yDimension)
        };
        this.ref = ref;
    }
    static assertRectangularMatrix(data) {
        if (data.length === 0)
            return;
        data.forEach((vector) => {
            if (vector.length !== data[0].length)
                throw new Error(`MultidimensionalChart data must be a rectangular matrix.`);
        });
    }
    static domains(data, expansionFactor) {
        if (data.length === 0)
            return [];
        return data[0].map((_, i) => {
            const values = data.map((vector) => vector[i]);
            return expandRange({
                start: Math.min(...values),
                end: Math.max(...values)
            }, expansionFactor);
        });
    }
    static displayData(data, xDimension, yDimension) {
        if (data.length === 0)
            return [];
        return data[0].map((_, i) => ({
            x: data[i][xDimension],
            y: data[i][yDimension]
        }));
    }
    static getDerivedStateFromProps(props, state) {
        const newState = Object.assign(Object.assign({}, state), { displayData: MultidimensionalChart.displayData(props.data, props.xDimension, props.yDimension) });
        if (props.data !== state.data) {
            MultidimensionalChart.assertRectangularMatrix(props.data);
            newState.domains = props.domains || MultidimensionalChart.domains(props.data, props.domainExpansionFactor || 0.1);
            newState.data = props.data;
        }
        return newState;
    }
    onSelectionEnd(selection, data) {
        this.props.onSelectionEnd && this.props.onSelectionEnd(selection, data[0]);
    }
    onFreeformSelectionEnd(selection, data) {
        this.props.onFreeformSelectionEnd && this.props.onFreeformSelectionEnd(selection, data[0]);
    }
    render() {
        let _a = this.props, { data, axisTitles, xAxisProps, yAxisProps, xDimension, yDimension, plotAreaProps } = _a, props = __rest(_a, ["data", "axisTitles", "xAxisProps", "yAxisProps", "xDimension", "yDimension", "plotAreaProps"]);
        axisTitles = axisTitles || [];
        xAxisProps = Object.assign({ title: axisTitles[xDimension] || `dimension ${xDimension}` }, (xAxisProps || {}));
        yAxisProps = Object.assign({ title: axisTitles[yDimension] || `dimension ${yDimension}` }, (yAxisProps || {}));
        plotAreaProps = Object.assign({ onSelectionEnd: this.onSelectionEnd.bind(this), onFreeformSelectionEnd: this.onFreeformSelectionEnd.bind(this) }, (plotAreaProps || {}));
        return (React.createElement(Chart, Object.assign({}, props, { plotAreaProps: plotAreaProps, domain: { x: this.state.domains[xDimension], y: this.state.domains[yDimension] }, scatterData: [this.state.displayData], xAxisProps: xAxisProps, yAxisProps: yAxisProps }),
            React.createElement(Scatter, Object.assign({ data: this.state.displayData }, this.props.scatterProps))));
    }
}
export default React.forwardRef((props, ref) => (React.createElement(MultidimensionalChart, Object.assign({ innerRef: ref }, props))));
